// Custom for page-specific dropzone
import { useDropzone } from 'react-dropzone'
import { HelpOther } from '@/common/helper'
import inputTypeStore from '../input-file/input-type'
import globalStore from '@/store/global'
import { SVGPureIcon } from '@/ui/svg-icon'
import { ACCEPT_FILE_TYPE, ACCEPT_IMG_TYPE } from '../input-file/shared'

const MAX_FILE_SIZE = 200;
const MAX_IMG_SIZE = 20;

export const usePageDropzone = (props) => {
    const { currAsstId } = props
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        noClick: true,
        noKeyboard: true,
    })
    const isFilesValid = files => {
        if (files.length > 10) {
          HelpOther.toast('最多选择10个文件', 'info');
          return false;
        }
        const fileList = Array.from(files);
        const imgList = fileList.filter(item => {
          const fileType = item.name.slice(item.name.lastIndexOf('.'));
          return ACCEPT_IMG_TYPE.includes(fileType.toLocaleLowerCase());
        });
        const docList = fileList.filter(item => {
          const fileType = item.name.slice(item.name.lastIndexOf('.'));
          return ACCEPT_FILE_TYPE.includes(fileType.toLocaleLowerCase());
        });
        if (imgList.length > 1 && imgList.length == fileList.length) {
          HelpOther.toast(`最多可上传一张图片`, 'info');
          return false;
        }
        if (imgList.length && docList.length) {
          HelpOther.toast(`请分别上传文件和图片`, 'info');
          return false;
        }
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const fileType = file.name.slice(file.name.lastIndexOf('.'));
          if (file.size > 1024 * 1024 * MAX_FILE_SIZE) {
            HelpOther.toast(`文件大小不能超过 ${MAX_FILE_SIZE}MB`, 'info');
            return false;
          }
          //只上传一张图片的情况
          if (
            files.length == 1 &&
            ACCEPT_IMG_TYPE.includes(fileType.toLocaleLowerCase())
          ) {
            if (file.size > 1024 * 1024 * MAX_IMG_SIZE) {
              HelpOther.toast(`图片大小不能超过 ${MAX_IMG_SIZE}MB`, 'info');
              return false;
            }
            return true;
          }
          if (!ACCEPT_FILE_TYPE.includes(fileType.toLocaleLowerCase())) {
            HelpOther.toast(`不支持的文件类型`, 'info');
            return false;
          }
        }
        return true;
      };

    const enhancedGetRootProps = (active) => {
        // console.info('>>> page drop-zone active? ', active)
        if (!active) return null
        const props = getRootProps({
            onDragOver: event => event.preventDefault(),
            onDrop: event => {
                event.preventDefault()
                const files = event.dataTransfer.files
                if (!isFilesValid(files)) return
                console.info('>>> Files', files)
                inputTypeStore.updateTempData('tempFile', files)
                // 拖放交互结束后关闭联网搜索
                globalStore.robotOnlineSo(currAsstId, false)
            },
        })
        return props
    }

    return {
        getRootProps: enhancedGetRootProps,
        isDragActive,
        DragArea: ({active}) => {
            if (!active) return null
            return (
                <div
                    className='absolute z-999 size-full left-0 top-0 px-[12px] py-[12px] pointer-events-none'
                    onDragOver={(event) => event.preventDefault()}
                >
                    <div className='size-full bg-[#f7f7f7] border-dashed border-[1px] rounded-[20px]'>
                        <div className='size-full flex items-center justify-center flex-col'>
                            <SVGPureIcon name="file2" className="size-48px opacity-[50%] mb-[10px]" />
                            {/* <img src={IconFile} className='w-[48px] h-[48px] mx-auto opacity-[50%] mb-[16px]' /> */}
                            <p className='font-500 text-[24px] leading-[34px] mb-[10px]'>拖放到此处上传</p>
                            <p className='text-[14px] text-color-[rgba(0,0,0,.5)] leading-[20px] mb-[4px]'>最多可上传10个文件（每个200MB以内）或1张图片（20MB以内）</p>
                            <p className='text-[14px] text-color-[rgba(0,0,0,.5)] leading-[20px] mb-0'>支持PDF、DOC、XLSX、TXT、JPG、PNG等多种格式</p>
                        </div>
                    </div>
                </div>
            )
        },
        HideInput: ({active}) => {
            if (!active) return null
            return <input {...getInputProps()} />
        },
    }
}
